import { useState } from 'react';
import { BarChart, Bar, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, AreaChart, Area, PieChart, Pie, Cell } from 'recharts';

export default function InformeComisionesReblone() {
  const [vista, setVista] = useState('resumen');
  const [anioDetalle, setAnioDetalle] = useState('todos');

  // ═══════════════════════════════════════
  // DATA
  // ═══════════════════════════════════════

  const resumenAnual = [
    { anio: '2020', polizas: 6288, recibos: 9809, primaNeta: 4522406.25, primaTotal: 5589395.62, comCorreduria: 1026379.08, comColaborador: 177574.21, pctCom: 19.95 },
    { anio: '2021', polizas: 7446, recibos: 11135, primaNeta: 5231898.31, primaTotal: 6548741.99, comCorreduria: 1193319.54, comColaborador: 199319.50, pctCom: 19.95 },
    { anio: '2022', polizas: 8332, recibos: 12884, primaNeta: 6248953.88, primaTotal: 7774297.87, comCorreduria: 1453839.60, comColaborador: 237334.37, pctCom: 20.03 },
    { anio: '2023', polizas: 9025, recibos: 14296, primaNeta: 7294448.76, primaTotal: 9012662.00, comCorreduria: 1663123.57, comColaborador: 272888.52, pctCom: 20.02 },
    { anio: '2024', polizas: 8350, recibos: 13058, primaNeta: 7258853.32, primaTotal: 8911012.23, comCorreduria: 1654344.33, comColaborador: 267420.57, pctCom: 20.00 },
    { anio: '2025', polizas: 8121, recibos: 13553, primaNeta: 8450202.04, primaTotal: 10298824.50, comCorreduria: 1912750.68, comColaborador: 313356.16, pctCom: 19.94 },
  ];

  const companias = [
    { compania: 'MAPFRE', polizas: 2535, recibos: 13764, primaNeta: 9035841, comCorreduria: 1977813, comCol: 332961, pct: 20.0 },
    { compania: 'OCASO', polizas: 2427, recibos: 11962, primaNeta: 6799338, comCorreduria: 1736278, comCol: 258813, pct: 20.0 },
    { compania: 'GENERALION', polizas: 1557, recibos: 7935, primaNeta: 3827633, comCorreduria: 944676, comCol: 147114, pct: 19.9 },
    { compania: 'GENERALI', polizas: 1480, recibos: 6795, primaNeta: 3020318, comCorreduria: 642282, comCol: 111191, pct: 20.0 },
    { compania: 'REALE', polizas: 1616, recibos: 6537, primaNeta: 2718079, comCorreduria: 605842, comCol: 105185, pct: 20.0 },
    { compania: 'ALLIANZ', polizas: 1291, recibos: 4481, primaNeta: 2597542, comCorreduria: 510414, comCol: 96755, pct: 20.0 },
    { compania: 'MUTUAP', polizas: 528, recibos: 2642, primaNeta: 1705246, comCorreduria: 398528, comCol: 72256, pct: 20.0 },
    { compania: 'OCCIDENT', polizas: 833, recibos: 3422, primaNeta: 1747636, comCorreduria: 401443, comCol: 64661, pct: 20.0 },
    { compania: 'AXA', polizas: 719, recibos: 3484, primaNeta: 1458981, comCorreduria: 319020, comCol: 55309, pct: 19.9 },
    { compania: 'CASER', polizas: 579, recibos: 2638, primaNeta: 1259602, comCorreduria: 257879, comCol: 47621, pct: 20.0 },
    { compania: 'HELVETIA', polizas: 404, recibos: 1929, primaNeta: 990958, comCorreduria: 262934, comCol: 38122, pct: 19.9 },
    { compania: 'ZURICH', polizas: 418, recibos: 1627, primaNeta: 935961, comCorreduria: 219248, comCol: 35008, pct: 19.9 },
    { compania: 'STLUCIA', polizas: 411, recibos: 1478, primaNeta: 874001, comCorreduria: 215714, comCol: 33490, pct: 20.1 },
    { compania: 'FIATC', polizas: 254, recibos: 1187, primaNeta: 740833, comCorreduria: 162742, comCol: 27741, pct: 20.1 },
    { compania: 'PLUSTRA', polizas: 347, recibos: 1233, primaNeta: 388668, comCorreduria: 67340, comCol: 11989, pct: 20.0 },
    { compania: 'MGS', polizas: 169, recibos: 562, primaNeta: 309953, comCorreduria: 77728, comCol: 11573, pct: 20.1 },
    { compania: 'Otros', polizas: 543, recibos: 3025, primaNeta: 551061, comCorreduria: 96697, comCol: 17059, pct: 20.0 },
  ];

  const companiasAnuales = {
    'MAPFRE': [
      { anio: '2020', comCol: 21752 }, { anio: '2021', comCol: 33333 }, { anio: '2022', comCol: 52925 },
      { anio: '2023', comCol: 70010 }, { anio: '2024', comCol: 67397 }, { anio: '2025', comCol: 87544 }
    ],
    'OCASO': [
      { anio: '2020', comCol: 19383 }, { anio: '2021', comCol: 27828 }, { anio: '2022', comCol: 35235 },
      { anio: '2023', comCol: 46413 }, { anio: '2024', comCol: 56879 }, { anio: '2025', comCol: 73076 }
    ],
    'GENERALION': [
      { anio: '2020', comCol: 24341 }, { anio: '2021', comCol: 24338 }, { anio: '2022', comCol: 28665 },
      { anio: '2023', comCol: 24761 }, { anio: '2024', comCol: 22208 }, { anio: '2025', comCol: 22802 }
    ],
    'GENERALI': [
      { anio: '2020', comCol: 15022 }, { anio: '2021', comCol: 15254 }, { anio: '2022', comCol: 18854 },
      { anio: '2023', comCol: 20952 }, { anio: '2024', comCol: 19544 }, { anio: '2025', comCol: 21565 }
    ],
    'REALE': [
      { anio: '2020', comCol: 19649 }, { anio: '2021', comCol: 16248 }, { anio: '2022', comCol: 16078 },
      { anio: '2023', comCol: 17656 }, { anio: '2024', comCol: 16917 }, { anio: '2025', comCol: 18636 }
    ],
    'ALLIANZ': [
      { anio: '2020', comCol: 18971 }, { anio: '2021', comCol: 17782 }, { anio: '2022', comCol: 15665 },
      { anio: '2023', comCol: 14935 }, { anio: '2024', comCol: 13384 }, { anio: '2025', comCol: 16017 }
    ],
    'STLUCIA': [
      { anio: '2020', comCol: 1841 }, { anio: '2021', comCol: 1623 }, { anio: '2022', comCol: 1343 },
      { anio: '2023', comCol: 5750 }, { anio: '2024', comCol: 8387 }, { anio: '2025', comCol: 14546 }
    ],
    'OCCIDENT': [
      { anio: '2020', comCol: 2626 }, { anio: '2021', comCol: 6907 }, { anio: '2022', comCol: 10890 },
      { anio: '2023', comCol: 13241 }, { anio: '2024', comCol: 14581 }, { anio: '2025', comCol: 16416 }
    ],
  };

  const topRamos = [
    { ramo: 'MRCDADPRO', primaNeta: 34650259, comCol: 1334894, pct: 90.3 },
    { ramo: 'MRHOGAR', primaNeta: 992235, comCol: 39061, pct: 2.6 },
    { ramo: 'TURISMOS', primaNeta: 1356060, comCol: 25425, pct: 1.7 },
    { ramo: 'RCGENERAL', primaNeta: 561478, comCol: 18615, pct: 1.3 },
    { ramo: 'MRCOMOFI', primaNeta: 320311, comCol: 12563, pct: 0.8 },
    { ramo: 'PDALQUILER', primaNeta: 219639, comCol: 8955, pct: 0.6 },
    { ramo: 'ENFASISCUA', primaNeta: 272149, comCol: 5682, pct: 0.4 },
    { ramo: 'MRINDUSTRI', primaNeta: 169044, comCol: 6521, pct: 0.4 },
    { ramo: 'VDINDRIESG', primaNeta: 156851, comCol: 5856, pct: 0.4 },
    { ramo: 'RCPROFESIO', primaNeta: 84851, comCol: 3326, pct: 0.2 },
    { ramo: 'Otros', primaNeta: 569884, comCol: 15997, pct: 1.1 },
  ];

  const dataMensual2025 = [
    { mes: 'Ene', comCol: 24660, primaNeta: 687608 },
    { mes: 'Feb', comCol: 26047, primaNeta: 722142 },
    { mes: 'Mar', comCol: 23046, primaNeta: 622622 },
    { mes: 'Abr', comCol: 24977, primaNeta: 674417 },
    { mes: 'May', comCol: 34328, primaNeta: 915677 },
    { mes: 'Jun', comCol: 18517, primaNeta: 491285 },
    { mes: 'Jul', comCol: 25005, primaNeta: 675441 },
    { mes: 'Ago', comCol: 26702, primaNeta: 723308 },
    { mes: 'Sep', comCol: 24780, primaNeta: 666054 },
    { mes: 'Oct', comCol: 20773, primaNeta: 552323 },
    { mes: 'Nov', comCol: 34379, primaNeta: 922727 },
    { mes: 'Dic', comCol: 30143, primaNeta: 796598 },
  ];

  // Colors
  const COLORS = ['#2563EB', '#DC2626', '#059669', '#7C3AED', '#EA580C', '#0891B2', '#4F46E5', '#CA8A04', '#BE185D', '#15803D', '#6366F1', '#64748B', '#0D9488', '#B45309', '#9333EA', '#1D4ED8', '#D97706'];
  
  const ciaColors = {
    'MAPFRE': '#DC2626', 'OCASO': '#2563EB', 'GENERALION': '#EA580C', 'GENERALI': '#7C3AED',
    'REALE': '#059669', 'ALLIANZ': '#4F46E5', 'STLUCIA': '#0891B2', 'OCCIDENT': '#CA8A04'
  };

  const fmt = (n) => n.toLocaleString('es-ES', { maximumFractionDigits: 0 });
  const fmtEur = (n) => n.toLocaleString('es-ES', { maximumFractionDigits: 2, minimumFractionDigits: 2 }) + ' €';

  // TOTALES ACUMULADOS
  const totalPrimaNeta = resumenAnual.reduce((s, r) => s + r.primaNeta, 0);
  const totalComCol = resumenAnual.reduce((s, r) => s + r.comColaborador, 0);
  const totalComCorr = resumenAnual.reduce((s, r) => s + r.comCorreduria, 0);
  const totalRecibos = resumenAnual.reduce((s, r) => s + r.recibos, 0);
  const crecComCol = ((resumenAnual[5].comColaborador - resumenAnual[0].comColaborador) / resumenAnual[0].comColaborador * 100).toFixed(1);

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white p-3 border border-gray-200 rounded-lg shadow-lg text-sm">
          <p className="font-semibold text-gray-800 mb-1">{label}</p>
          {payload.map((entry, i) => (
            <div key={i} className="flex justify-between gap-4">
              <span style={{ color: entry.color }}>{entry.name}:</span>
              <span className="font-medium">{fmtEur(entry.value)}</span>
            </div>
          ))}
        </div>
      );
    }
    return null;
  };

  // ═══════════════════════════════════════
  // RENDER SECTIONS
  // ═══════════════════════════════════════

  const renderResumen = () => (
    <>
      {/* KPIs principales */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        {[
          { label: 'Comisión Total Acumulada', value: fmtEur(totalComCol), sub: '2020-2025', color: 'border-emerald-500', textColor: 'text-emerald-700' },
          { label: 'Crecimiento Com. 2020→2025', value: `+${crecComCol}%`, sub: `${fmtEur(resumenAnual[0].comColaborador)} → ${fmtEur(resumenAnual[5].comColaborador)}`, color: 'border-blue-500', textColor: 'text-blue-700' },
          { label: 'Prima Neta Intermediada', value: fmtEur(totalPrimaNeta), sub: 'Acumulado 6 años', color: 'border-purple-500', textColor: 'text-purple-700' },
          { label: 'Total Recibos Liquidados', value: fmt(totalRecibos), sub: `% Com. media: ${(totalComCol / totalComCorr * 100).toFixed(1)}% s/corr`, color: 'border-orange-500', textColor: 'text-orange-700' },
        ].map((kpi, i) => (
          <div key={i} className={`bg-white rounded-xl p-4 shadow-sm border-l-4 ${kpi.color}`}>
            <p className="text-gray-500 text-xs font-medium">{kpi.label}</p>
            <p className={`text-xl font-bold ${kpi.textColor} mt-1`}>{kpi.value}</p>
            <p className="text-gray-400 text-xs mt-1">{kpi.sub}</p>
          </div>
        ))}
      </div>

      {/* Gráfica evolución anual */}
      <div className="bg-white rounded-xl shadow-sm p-5 mb-6">
        <h3 className="text-sm font-semibold text-gray-700 mb-4">Evolución Anual — Comisión Colaborador vs Prima Neta</h3>
        <ResponsiveContainer width="100%" height={320}>
          <BarChart data={resumenAnual} margin={{ top: 10, right: 30, left: 20, bottom: 10 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" />
            <XAxis dataKey="anio" tick={{ fill: '#6B7280', fontSize: 12 }} />
            <YAxis yAxisId="left" tickFormatter={(v) => `${(v/1000).toFixed(0)}k`} tick={{ fill: '#6B7280', fontSize: 11 }} />
            <YAxis yAxisId="right" orientation="right" tickFormatter={(v) => `${(v/1000000).toFixed(1)}M`} tick={{ fill: '#6B7280', fontSize: 11 }} />
            <Tooltip content={<CustomTooltip />} />
            <Bar yAxisId="left" dataKey="comColaborador" name="Com. Colaborador" fill="#10B981" radius={[6, 6, 0, 0]} />
            <Line yAxisId="right" type="monotone" dataKey="primaNeta" name="Prima Neta" stroke="#2563EB" strokeWidth={2.5} dot={{ r: 4 }} />
          </BarChart>
        </ResponsiveContainer>
      </div>

      {/* Tabla resumen anual */}
      <div className="bg-white rounded-xl shadow-sm p-5">
        <h3 className="text-sm font-semibold text-gray-700 mb-3">Detalle por Año</h3>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b-2 border-gray-200">
                {['Año', 'Pólizas', 'Recibos', 'Prima Neta', 'Prima Total', 'Com. Correduría', 'Com. Colaborador', '% Var.'].map(h => (
                  <th key={h} className="text-right py-2.5 px-3 font-semibold text-gray-500 text-xs first:text-left">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {resumenAnual.map((r, i) => {
                const prev = i > 0 ? resumenAnual[i - 1].comColaborador : null;
                const varPct = prev ? ((r.comColaborador - prev) / prev * 100).toFixed(1) : null;
                return (
                  <tr key={r.anio} className="border-b border-gray-50 hover:bg-blue-50/50">
                    <td className="py-2.5 px-3 font-semibold text-gray-800">{r.anio}</td>
                    <td className="py-2.5 px-3 text-right">{fmt(r.polizas)}</td>
                    <td className="py-2.5 px-3 text-right">{fmt(r.recibos)}</td>
                    <td className="py-2.5 px-3 text-right font-medium">{fmtEur(r.primaNeta)}</td>
                    <td className="py-2.5 px-3 text-right">{fmtEur(r.primaTotal)}</td>
                    <td className="py-2.5 px-3 text-right">{fmtEur(r.comCorreduria)}</td>
                    <td className="py-2.5 px-3 text-right font-bold text-emerald-700">{fmtEur(r.comColaborador)}</td>
                    <td className="py-2.5 px-3 text-right">
                      {varPct ? (
                        <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${parseFloat(varPct) >= 0 ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                          {parseFloat(varPct) >= 0 ? '+' : ''}{varPct}%
                        </span>
                      ) : '—'}
                    </td>
                  </tr>
                );
              })}
              <tr className="border-t-2 border-gray-300 bg-gray-50 font-bold">
                <td className="py-2.5 px-3">TOTAL</td>
                <td className="py-2.5 px-3 text-right">—</td>
                <td className="py-2.5 px-3 text-right">{fmt(totalRecibos)}</td>
                <td className="py-2.5 px-3 text-right">{fmtEur(totalPrimaNeta)}</td>
                <td className="py-2.5 px-3 text-right">{fmtEur(resumenAnual.reduce((s, r) => s + r.primaTotal, 0))}</td>
                <td className="py-2.5 px-3 text-right">{fmtEur(totalComCorr)}</td>
                <td className="py-2.5 px-3 text-right text-emerald-700">{fmtEur(totalComCol)}</td>
                <td className="py-2.5 px-3 text-right">—</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );

  const renderCompanias = () => (
    <>
      {/* Top compañías pie chart + evolución */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
        <div className="bg-white rounded-xl shadow-sm p-5">
          <h3 className="text-sm font-semibold text-gray-700 mb-4">Distribución Comisión por Compañía</h3>
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <Pie data={companias.slice(0, 10)} dataKey="comCol" nameKey="compania" cx="50%" cy="50%" innerRadius={60} outerRadius={110} paddingAngle={2}>
                {companias.slice(0, 10).map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
              </Pie>
              <Tooltip formatter={(v) => fmtEur(v)} />
            </PieChart>
          </ResponsiveContainer>
          <div className="flex flex-wrap gap-2 mt-2 justify-center">
            {companias.slice(0, 10).map((c, i) => (
              <span key={c.compania} className="flex items-center gap-1 text-xs text-gray-600">
                <span className="w-2.5 h-2.5 rounded-full inline-block" style={{ backgroundColor: COLORS[i] }} />
                {c.compania}
              </span>
            ))}
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-sm p-5">
          <h3 className="text-sm font-semibold text-gray-700 mb-4">Evolución Top Compañías</h3>
          <ResponsiveContainer width="100%" height={300}>
            <LineChart margin={{ top: 10, right: 20, left: 10, bottom: 10 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" />
              <XAxis dataKey="anio" type="category" allowDuplicatedCategory={false} tick={{ fill: '#6B7280', fontSize: 11 }} />
              <YAxis tickFormatter={(v) => `${(v/1000).toFixed(0)}k`} tick={{ fill: '#6B7280', fontSize: 11 }} />
              <Tooltip formatter={(v) => fmtEur(v)} />
              {Object.entries(ciaColors).map(([cia, color]) => (
                <Line key={cia} data={companiasAnuales[cia]} type="monotone" dataKey="comCol" name={cia} stroke={color} strokeWidth={2} dot={{ r: 3 }} />
              ))}
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>

      {/* Tabla compañías */}
      <div className="bg-white rounded-xl shadow-sm p-5">
        <h3 className="text-sm font-semibold text-gray-700 mb-3">Ranking por Compañía (Acumulado 2020-2025)</h3>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b-2 border-gray-200">
                {['#', 'Compañía', 'Pólizas', 'Recibos', 'Prima Neta', 'Com. Correduría', 'Com. Colaborador', '% Com.'].map(h => (
                  <th key={h} className="text-right py-2.5 px-3 font-semibold text-gray-500 text-xs first:text-left">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {companias.map((c, i) => (
                <tr key={c.compania} className="border-b border-gray-50 hover:bg-blue-50/50">
                  <td className="py-2 px-3 text-gray-400 font-medium">{i + 1}</td>
                  <td className="py-2 px-3">
                    <div className="flex items-center gap-2">
                      <div className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: COLORS[i % COLORS.length] }} />
                      <span className="font-medium text-gray-800">{c.compania}</span>
                    </div>
                  </td>
                  <td className="py-2 px-3 text-right">{fmt(c.polizas)}</td>
                  <td className="py-2 px-3 text-right">{fmt(c.recibos)}</td>
                  <td className="py-2 px-3 text-right">{fmtEur(c.primaNeta)}</td>
                  <td className="py-2 px-3 text-right">{fmtEur(c.comCorreduria)}</td>
                  <td className="py-2 px-3 text-right font-bold text-emerald-700">{fmtEur(c.comCol)}</td>
                  <td className="py-2 px-3 text-right">
                    <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-blue-50 text-blue-700">{c.pct}%</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );

  const renderRamos = () => (
    <>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
        <div className="bg-white rounded-xl shadow-sm p-5">
          <h3 className="text-sm font-semibold text-gray-700 mb-4">Distribución Comisión por Ramo</h3>
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <Pie data={topRamos} dataKey="comCol" nameKey="ramo" cx="50%" cy="50%" innerRadius={60} outerRadius={110} paddingAngle={2}>
                {topRamos.map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
              </Pie>
              <Tooltip formatter={(v) => fmtEur(v)} />
            </PieChart>
          </ResponsiveContainer>
          <div className="flex flex-wrap gap-2 mt-2 justify-center">
            {topRamos.map((r, i) => (
              <span key={r.ramo} className="flex items-center gap-1 text-xs text-gray-600">
                <span className="w-2.5 h-2.5 rounded-full inline-block" style={{ backgroundColor: COLORS[i] }} />
                {r.ramo}
              </span>
            ))}
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-sm p-5">
          <h3 className="text-sm font-semibold text-gray-700 mb-4">Top 10 Ramos — Comisión Acumulada</h3>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={topRamos.slice(0, 10)} layout="vertical" margin={{ top: 5, right: 30, left: 70, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" />
              <XAxis type="number" tickFormatter={(v) => `${(v/1000).toFixed(0)}k`} tick={{ fill: '#6B7280', fontSize: 11 }} />
              <YAxis type="category" dataKey="ramo" tick={{ fill: '#374151', fontSize: 11 }} width={65} />
              <Tooltip formatter={(v) => fmtEur(v)} />
              <Bar dataKey="comCol" name="Com. Colaborador" fill="#10B981" radius={[0, 6, 6, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>

      <div className="bg-white rounded-xl shadow-sm p-5">
        <h3 className="text-sm font-semibold text-gray-700 mb-3">Detalle por Ramo (Acumulado 2020-2025)</h3>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b-2 border-gray-200">
                {['Ramo', 'Prima Neta', 'Com. Colaborador', '% del Total'].map(h => (
                  <th key={h} className="text-right py-2.5 px-3 font-semibold text-gray-500 text-xs first:text-left">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {topRamos.map((r, i) => (
                <tr key={r.ramo} className="border-b border-gray-50 hover:bg-blue-50/50">
                  <td className="py-2 px-3">
                    <div className="flex items-center gap-2">
                      <div className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: COLORS[i % COLORS.length] }} />
                      <span className="font-medium">{r.ramo}</span>
                    </div>
                  </td>
                  <td className="py-2 px-3 text-right">{fmtEur(r.primaNeta)}</td>
                  <td className="py-2 px-3 text-right font-bold text-emerald-700">{fmtEur(r.comCol)}</td>
                  <td className="py-2 px-3 text-right">
                    <div className="flex items-center gap-2 justify-end">
                      <div className="w-16 bg-gray-100 rounded-full h-2">
                        <div className="h-2 rounded-full bg-emerald-500" style={{ width: `${Math.min(r.pct * 1.1, 100)}%` }} />
                      </div>
                      <span className="text-xs text-gray-600 w-10 text-right">{r.pct}%</span>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );

  const renderMensual = () => (
    <>
      <div className="bg-white rounded-xl shadow-sm p-5 mb-6">
        <h3 className="text-sm font-semibold text-gray-700 mb-4">Detalle Mensual 2025 — Comisión Liquidada</h3>
        <ResponsiveContainer width="100%" height={320}>
          <AreaChart data={dataMensual2025} margin={{ top: 10, right: 30, left: 20, bottom: 10 }}>
            <defs>
              <linearGradient id="gradCom" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#10B981" stopOpacity={0.7} />
                <stop offset="95%" stopColor="#10B981" stopOpacity={0.05} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" />
            <XAxis dataKey="mes" tick={{ fill: '#6B7280', fontSize: 12 }} />
            <YAxis tickFormatter={(v) => `${(v/1000).toFixed(0)}k`} tick={{ fill: '#6B7280', fontSize: 11 }} />
            <Tooltip content={<CustomTooltip />} />
            <Area type="monotone" dataKey="comCol" name="Com. Colaborador" stroke="#10B981" strokeWidth={2.5} fill="url(#gradCom)" />
          </AreaChart>
        </ResponsiveContainer>
      </div>

      <div className="bg-white rounded-xl shadow-sm p-5">
        <h3 className="text-sm font-semibold text-gray-700 mb-3">Tabla Mensual 2025</h3>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b-2 border-gray-200">
                {['Mes', 'Prima Neta', 'Com. Colaborador', 'Media mensual'].map(h => (
                  <th key={h} className="text-right py-2.5 px-3 font-semibold text-gray-500 text-xs first:text-left">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {dataMensual2025.map((m, i) => {
                const media = dataMensual2025.slice(0, i + 1).reduce((s, x) => s + x.comCol, 0) / (i + 1);
                return (
                  <tr key={m.mes} className="border-b border-gray-50 hover:bg-blue-50/50">
                    <td className="py-2 px-3 font-medium">{m.mes} 2025</td>
                    <td className="py-2 px-3 text-right">{fmtEur(m.primaNeta)}</td>
                    <td className="py-2 px-3 text-right font-bold text-emerald-700">{fmtEur(m.comCol)}</td>
                    <td className="py-2 px-3 text-right text-gray-500">{fmtEur(media)}</td>
                  </tr>
                );
              })}
              <tr className="border-t-2 border-gray-300 bg-gray-50 font-bold">
                <td className="py-2.5 px-3">TOTAL 2025</td>
                <td className="py-2.5 px-3 text-right">{fmtEur(dataMensual2025.reduce((s, m) => s + m.primaNeta, 0))}</td>
                <td className="py-2.5 px-3 text-right text-emerald-700">{fmtEur(dataMensual2025.reduce((s, m) => s + m.comCol, 0))}</td>
                <td className="py-2.5 px-3 text-right text-gray-500">{fmtEur(dataMensual2025.reduce((s, m) => s + m.comCol, 0) / 12)}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );

  // ═══════════════════════════════════════
  // MAIN LAYOUT
  // ═══════════════════════════════════════

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-emerald-50/30 p-4 sm:p-6">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="bg-white rounded-2xl shadow-sm p-6 mb-6 border-b-4 border-emerald-500">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
            <div>
              <p className="text-xs font-medium text-emerald-600 uppercase tracking-wider">Informe de Comisiones Liquidadas</p>
              <h1 className="text-2xl font-bold text-gray-800 mt-1">REBLONE SOLUCIONES, SL</h1>
              <p className="text-gray-500 text-sm mt-0.5">COL_Id: 100948 · Período: 2020 – 2025</p>
            </div>
            <div className="text-right">
              <p className="text-xs text-gray-400">Comisión Total Acumulada</p>
              <p className="text-3xl font-bold text-emerald-600">{fmtEur(totalComCol)}</p>
            </div>
          </div>
        </div>

        {/* Navigation */}
        <div className="flex flex-wrap gap-2 mb-6">
          {[
            { id: 'resumen', label: '📊 Resumen Anual' },
            { id: 'companias', label: '🏢 Por Compañía' },
            { id: 'ramos', label: '📋 Por Ramo' },
            { id: 'mensual', label: '📅 Mensual 2025' },
          ].map(tab => (
            <button
              key={tab.id}
              onClick={() => setVista(tab.id)}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                vista === tab.id
                  ? 'bg-emerald-600 text-white shadow-md'
                  : 'bg-white text-gray-600 hover:bg-gray-100 shadow-sm'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* Content */}
        {vista === 'resumen' && renderResumen()}
        {vista === 'companias' && renderCompanias()}
        {vista === 'ramos' && renderRamos()}
        {vista === 'mensual' && renderMensual()}

        {/* Footer */}
        <p className="text-center text-gray-400 text-xs mt-6">
          Datos extraídos de COLREC · Liquidaciones no anuladas · Base: "4212SE".dbo · Generado: Feb 2026
        </p>
      </div>
    </div>
  );
}
